export const routes = {
  signIn: '/sign-in',

  customer(customerId: string) : string {
    return `/customers/${customerId}`;
  },

  reservation(reservationId: string) : string {
    return `/reservations/${reservationId}`;
  }
} as const;
